/* eslint-disable radix */
'use strict';
const hexRgb = function(hex) {
	if (typeof hex !== 'string') {
		throw new TypeError('Expected a string');
	}

	hex = hex.replace(/^#/, '');

	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}
	const num = parseInt(hex, 16);
	if (hex.length === 6) {
		return [num >> 16, (num >> 8) & 255, num & 255];
	}

	if (hex.length === 8) {
		return [(num >> 24) & 255, (num >> 16) & 255, (num >> 8) & 255, (num & 255) / 255];
	}
};
const rgbToHsb = function(arr) {
	let h = 0,
		s = 0,
		v = 0;
	const r = arr[0],
		g = arr[1],
		b = arr[2];
	arr.sort(function(a, b) {
		return a - b;
	});
	const max = arr[2];
	const min = arr[0];
	v = max / 255;
	if (max === 0) {
		s = 0;
	} else {
		s = 1 - min / max;
	}
	if (max === min) {
		h = 0; //事实上，max===min的时候，h无论为多少都无所谓
	} else if (max === r && g >= b) {
		h = 60 * ((g - b) / (max - min)) + 0;
	} else if (max === r && g < b) {
		h = 60 * ((g - b) / (max - min)) + 360;
	} else if (max === g) {
		h = 60 * ((b - r) / (max - min)) + 120;
	} else if (max === b) {
		h = 60 * ((r - g) / (max - min)) + 240;
	}
	h = parseInt(h);
	s = parseInt(s * 100);
	v = parseInt(v * 100);
	return [h, s, v];
};
const hsbToRgb = function(arr) {
	// eslint-disable-next-line prefer-const
	let h = arr[0],
		s = arr[1],
		v = arr[2];
	s = s / 100;
	v = v / 100;
	let r = 0,
		g = 0,
		b = 0;
	const i = parseInt((h / 60) % 6);
	const f = h / 60 - i;
	const p = v * (1 - s);
	const q = v * (1 - f * s);
	const t = v * (1 - (1 - f) * s);
	switch (i) {
		case 0:
			r = v;
			g = t;
			b = p;
			break;
		case 1:
			r = q;
			g = v;
			b = p;
			break;
		case 2:
			r = p;
			g = v;
			b = t;
			break;
		case 3:
			r = p;
			g = q;
			b = v;
			break;
		case 4:
			r = t;
			g = p;
			b = v;
			break;
		case 5:
			r = v;
			g = p;
			b = q;
			break;
		default:
			break;
	}
	r = parseInt(r * 255.0);
	g = parseInt(g * 255.0);
	b = parseInt(b * 255.0);
	return [r, g, b];
};
const hexTransLateHsbToRgb = function(hex, changeNum) {
	// hex值根据UI提供的算法转换颜色
	const arr = hexRgb(hex);
	const rgbArr = arr.slice(0, 3);
	const hsbArr = rgbToHsb(rgbArr);
	hsbArr[1] = hsbArr[1] - changeNum;
	const transArr = hsbToRgb(hsbArr);
	return `rgb(${transArr[0]},${transArr[1]},${transArr[2]})`;
};
/**
 * RGB 颜色值转换为 HSL.
 * 转换公式参考自 http://en.wikipedia.org/wiki/HSL_color_space.
 * r, g, 和 b 需要在 [0, 255] 范围内
 * 返回的 h, s, 和 l 在 [0, 1] 之间
 *
 * @param   Number  r       红色色值
 * @param   Number  g       绿色色值
 * @param   Number  b       蓝色色值
 * @return  Array           HSL各值数组
 */
const rgbToHsl = ([r, g, b]) => {
	r = r / 255;
	g = g / 255;
	b = b / 255;
	const max = Math.max(r, g, b),
		min = Math.min(r, g, b);
	let h,
		s,
		l = (max + min) / 2;

	if (max == min) {
		h = s = 0; // achromatic
	} else {
		const d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch (max) {
			case r:
				h = (g - b) / d + (g < b ? 6 : 0);
				break;
			case g:
				h = (b - r) / d + 2;
				break;
			case b:
				h = (r - g) / d + 4;
				break;
			default:
				break;
		}
		h /= 6;
	}

	return [h, s, l];
};
/**
 * HSL颜色值转换为RGB.
 * 换算公式改编自 http://en.wikipedia.org/wiki/HSL_color_space.
 * h, s, 和 l 设定在 [0, 1] 之间
 * 返回的 r, g, 和 b 在 [0, 255]之间
 *
 * @param   Number  h       色相
 * @param   Number  s       饱和度
 * @param   Number  l       亮度
 * @return  Array           RGB色值数值
 */
const hslToRgb = ([h, s, l]) => {
	let r, g, b;
	if (s == 0) {
		r = g = b = l; // achromatic
	} else {
		const hue2rgb = function hue2rgb(p, q, t) {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		};

		const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		const p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}

	return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
};
const hexTransLateHslToRgb = function(hex, changeNum, opacity) {
	// hex值根据UI提供的算法转换颜色
	const arr = hexRgb(hex);
	const rgbArr = arr.slice(0, 3);
	const hsbArr = rgbToHsl(rgbArr);
	hsbArr[2] = hsbArr[2] * changeNum;
	const transArr = hslToRgb(hsbArr);
	if (opacity) {
		return `rgba(${transArr[0]},${transArr[1]},${transArr[2]},${opacity})`;
	}
	return `rgb(${transArr[0]},${transArr[1]},${transArr[2]})`;
};
export default hexRgb;
export { hexRgb, hsbToRgb, rgbToHsb, hexTransLateHsbToRgb, hexTransLateHslToRgb };
